module.exports = __webpack_public_path__ + "img/footer-background.7a4736fb.jpg";